/* eslint-disable */
import style from '../styles/main.scss';
import 'lazysizes';
import 'lazysizes/plugins/bgset/ls.bgset'
import 'lazysizes/plugins/respimg/ls.respimg'
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks'
/** import external dependencies */
import $ from 'jquery';

/** import local dependencies */
import Slider from './components/slider.js';
Slider.init();

import Expandable from './components/expandable.js';
Expandable.init({
  target: '.js-expand-target',
  label: '.label',
  click: '.js-expand-click',
});


import ExpandableToggle from './components/expandableToggle.js';
ExpandableToggle.init()

import Header from './components/header.js';
Header.init()

import Ripple from './components/ripple.js';
Ripple.init()
import toTop from './components/toTop.js';
toTop.init()
import toActive from './components/scrollToActive.js';
toActive.init()
import youtubeOverlayClick from './components/youtube-overlay-click.js';
youtubeOverlayClick.init()

import Hero from './components/hero';
Hero.init()

import ProductInfo from './components/product-info'
ProductInfo.init()

import Carousel from './components/carousel'
Carousel.init()

import Search from './components/SearchSuggestion'
new Search()

import Webinars from './components/webinars'
Webinars.init()

import Webinarsfilter from './components/webinars-language-filter'
Webinarsfilter.init()
import StaffMemberScroll from './components/StaffmemberScroll'
StaffMemberScroll.init()

$(document).ready(function (e) {
  $('.embed-responsive').on('click', function() {
    $('.embed-responsive').addClass('video-playing');
  });

  let UrlsObj = localStorage.getItem('rememberScroll');
  let ParseUrlsObj = JSON.parse(UrlsObj);
  let windowUrl = window.location.href;

  if (ParseUrlsObj == null) {
      return false;
  }

  ParseUrlsObj.forEach(function (el) {
      if (el.url === windowUrl) {
          let getPos = el.scroll;
          $(window).scrollTop(getPos);
      }
  });



});

function RememberScrollPage(scrollPos) {

  let UrlsObj = localStorage.getItem('rememberScroll');
  let urlsArr = JSON.parse(UrlsObj);

  if (urlsArr == null) {
      urlsArr = [];
  }

  if (urlsArr.length == 0) {
      urlsArr = [];
  }

  let urlWindow = window.location.href;
  let urlScroll = scrollPos;
  let urlObj = {url: urlWindow, scroll: scrollPos};
  let matchedUrl = false;
  let matchedIndex = 0;

  if (urlsArr.length != 0) {
      urlsArr.forEach(function (el, index) {

          if (el.url === urlWindow) {
              matchedUrl = true;
              matchedIndex = index;
          }

      });

      if (matchedUrl === true) {
          urlsArr[matchedIndex].scroll = urlScroll;
      } else {
          urlsArr.push(urlObj);
      }


  } else {
      urlsArr.push(urlObj);
  }

  localStorage.setItem('rememberScroll', JSON.stringify(urlsArr));

}

$(window).scroll(function (event) {
  let topScroll = $(window).scrollTop();
  // console.log('Scrolling', topScroll);
  RememberScrollPage(topScroll);
});